// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icd-codes .indicatives ul[data-v-d1fb387e] {\n  display: flex;\n}\n.icd-codes .indicatives ul li[data-v-d1fb387e] {\n  margin: 0 6px;\n}\n.icd-codes .indicatives ul li p .value[data-v-d1fb387e] {\n  padding: 3px 12px !important;\n}", ""]);
// Exports
module.exports = exports;
